// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2IJzh","alertIcon":"ConfirmModal_alertIcon__3HNYg"};